import { useTranslation } from 'react-i18next';
import { Box, Typography } from '../../../1-primative';
import { Button } from '../../../2-component';

interface StatementResponse {
  id: string;
  state: string;
  type: string;
  account: {
    id: string;
    type: string;
  };
  user: {
    id: string;
    firstName: string;
    lastName: string;
    organization: {
      name: string;
    };
  };
  totalCount: number;
}

const StatementsSelectionInfo = ({
  selected,
  allItemsOnPageSelected,
  transitionAll,
  statementResponse,
  totalCount,
  setTransitionAll, setSelected,
}: {
  selected: string[];
  allItemsOnPageSelected: boolean;
  transitionAll: boolean;
  statementResponse: StatementResponse[];
  totalCount: number;
  setTransitionAll: (value: boolean) => void;
  setSelected: (value: string[]) => void;
}) => {
  const { t } = useTranslation(['statementsReview']);

  if (selected.length === 0) return null;

  if (!allItemsOnPageSelected && !transitionAll) {
    return (
      <Typography variant='bodySmall'>
        {t('statementsReview:transitionStatements.rowsSelected', { selectedCount: selected.length })}
      </Typography>
    );
  }

  return (
    <Box display='flex' alignItems='center' gap={2}>
      {!transitionAll ? (
        <>
          <Typography variant='bodySmall'>
            {t('statementsReview:transitionStatements.allRowsOnPageSelected', {
              totalCount: statementResponse.length,
              selectedCount: selected.length,
            })}
          </Typography>
          <Button
            dataTestId='statements-review-select-all-button'
            variant='outlined'
            size='xs'
            label={t('statementsReview:transitionStatements.selectAll', { totalCount })}
            onClick={() => setTransitionAll(true)}
          />
        </>
      ) : (
        <>
          <Typography variant='bodySmall'>
            {t('statementsReview:transitionStatements.totalCount', { totalCount })}
          </Typography>
          <Button
            dataTestId='statements-review-clear-selection-button'
            variant='outlined'
            size='xs'
            label={t('statementsReview:transitionStatements.clearSelectionButton')}
            onClick={() => {
              setTransitionAll(false);
              setSelected([]);
            }}
          />
        </>
      )}
    </Box>
  );
};

export default StatementsSelectionInfo;
